export default __webpack_public_path__ + "media/images/elephant_ui_conversation-ce5da9efc38e8f682b127a099d34650f.svg";